import { render, staticRenderFns } from "./EditableTable.vue?vue&type=template&id=fba01584&scoped=true&"
import script from "./EditableTable.vue?vue&type=script&lang=js&"
export * from "./EditableTable.vue?vue&type=script&lang=js&"
import style0 from "./EditableTable.vue?vue&type=style&index=0&id=fba01584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba01584",
  null
  
)

export default component.exports